var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMap = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M22.5 1.15c.3-.2.7-.2 1 0 .3.198.5.497.5.895v15.928c0 .398-.2.697-.5.896l-7 3.982h-.2c-.1.1-.2.1-.3.1-.2 0-.3 0-.5-.1L8 19.068 1.5 22.85c-.3.199-.7.199-1 0-.3-.2-.5-.498-.5-.896V6.027c0-.398.2-.697.4-.896l7-3.982h.2c.2-.1.3-.1.4-.1s.2 0 .3.1h.1L16 4.932zM15 6.623 9 3.638v13.738l6 2.986zm-13 0 5-2.886v13.638l-5 2.886zm15 13.638 5-2.886V3.738l-5 2.886v13.638z",
  clipRule: "evenodd"
})));
export default SvgMap;